import {selectSharedGameState} from './selectors';

/**
 * Чат матча в состоянии партии. Признаки приходят с START_GAME (сервер
 * включает их только ИИ-матчу) и попадают в запись матча — поэтому чат
 * есть и у зрителей, и при просмотре записи.
 */

// Чат включен в этой партии — панель чата показывается и в прод-сборке
export const selectIsMatchChatEnabled = (state) => Boolean(selectSharedGameState(state)?.chatEnabled);

// Модерируемый чат ИИ-матча: сообщения идут через очередь модератора
// (CHAT_SEND), а не прямым ADD_CHAT_MESSAGE, как у локальных матчей агентов
export const selectIsModeratedChat = (state) => {
  const gameState = selectSharedGameState(state);
  return Boolean(gameState?.isAiMatch && gameState?.chatEnabled);
};
